(() => {
  'use strict';

  const FORM_ID_ATTR = 'data-klaviyo-form-id';
  const TRIGGER_HASH = 'klaviyo-form';
  const DEFAULT_FORM_ID = 'XviNaq';

  const getHrefHash = (anchor) => {
    const href = (anchor.getAttribute('href') || '').trim();
    if (!href) return '';

    if (href.charAt(0) === '#') {
      return href.slice(1).toLowerCase();
    }

    try {
      return new URL(href, window.location.origin).hash.replace(/^#/, '').toLowerCase();
    } catch (error) {
      return '';
    }
  };

  const getFormId = (anchor) => {
    const fromAnchor = (anchor.getAttribute(FORM_ID_ATTR) || '').trim();
    if (fromAnchor) return fromAnchor;

    const container = anchor.closest(`[${FORM_ID_ATTR}]`);
    const fromContainer = (container?.getAttribute(FORM_ID_ATTR) || '').trim();
    if (fromContainer) return fromContainer;

    return DEFAULT_FORM_ID;
  };

  const isKlaviyoTrigger = (anchor) => {
    if (!anchor || anchor.tagName !== 'A') return false;
    if (anchor.classList.contains('klaviyo_form_trigger')) return true;
    return getHrefHash(anchor) === TRIGGER_HASH;
  };

  const openKlaviyoForm = (formId) => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

    if (typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm(formId);
    }

    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(formId);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('a');
      if (!isKlaviyoTrigger(trigger)) return;

      event.preventDefault();
      event.stopPropagation();
      openKlaviyoForm(getFormId(trigger));
    },
    true,
  );
})();
